import Request from '@hotmart-org-ca/request'

import Settings from 'common/helpers/settings/.'

Request.register(`${Settings.api.lead}`, {
  post: {
    'post.lead': '/v2/lead'
  },
  get: {
    'get.lead.accepted': '/v1/lead/accepted'
  }
})
